import $ from 'jquery';
function navigation() {
    $(window).scroll(function(){
        $('nav').toggleClass('scrolled', $(this).scrollTop() > 100);
    });
}

export default navigation();